import { render } from "./CreateNewButton.vue?vue&type=template&id=282860f4"
import script from "./CreateNewButton.vue?vue&type=script&lang=js"
export * from "./CreateNewButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__